import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserProvider';
import PropTypes from 'prop-types';
import LoadingScreen from './LoadingScreen';

const ALLOWED_ROUTES = ['/about', '/terms', '/contact', '/policy'];

function PublicRoute({ children }) {
  const location = useLocation();
  const { user: kipUser, firebaseUser, initialized } = useUser();

  if (!initialized) {
    return <LoadingScreen />;
  }

  if (ALLOWED_ROUTES.includes(location.pathname)) {
    return children;
  }

  // Fix the condition to handle undefined properly
  if (firebaseUser != null || kipUser != null) {
    return <Navigate to="/home" replace />;
  }

  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PublicRoute;
